import store from "../redux/create-store";

declare const window: any;

export function initCTRAttributes() {
  window.sendCTRItemToAmazonConnect = window.sendCTRItemToAmazonConnect || {}
}

export function updateVaoEligibilityFlag(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { vaoEligibilityFlag: `${conversationId}: ${value}` })
  }
}

export function updateConsentSend(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { consentSend: `${conversationId}: ${value}` })
  }
}

export function updateConsentReceived(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { consentReceived: `${conversationId}: ${value}` })
  }
}

export function updateOfferPitchFlag(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { offerPitchFlag: `${conversationId}: ${value}` })
  }
}

export function updateOfferAcceptedFlag(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { offerAcceptedFlag: `${conversationId}: ${value}` })
  }
}

export function updateCustomerSearchClick(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { customerSearchClick: `${conversationId}: ${value}` })
  }
}
// latest pitched offer id
export function updateOfferId(conversationId: string, offerId: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { offerId: `${conversationId}: ${offerId}` })
  }
}

export function updateEligibleOffersPitched(conversationId: string, offerId: string) {
  const oldPattern = `${offerId}: No`;
  const newPattern = `${offerId}: Yes`;
  const sessionStorageData = getCurrentContactCTRData(conversationId);
  const { EligibleOffersPitchedValue } = sessionStorageData || {};
  const updatedEligibleOffersPitchedValue = EligibleOffersPitchedValue?.replace(oldPattern, newPattern) || 'NA';

  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { EligibleOffersPitched: `${updatedEligibleOffersPitchedValue}` })
  }
}

export function updateEligibleOffersPitchedToDefault(conversationId: string, allOfferDetails: string) {

  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { EligibleOffersPitched: `${conversationId}: ${allOfferDetails || 'NA'}` })
  }
}


export function updateValueAddActionSales(conversationId: string, value: string) {

  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { valueAddActionSales: value })
  }
}

export function updateValueAddActionSupport(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { valueAddActionSupport: value })
  }
}

// CSME-91691
export function updateSourceAttribute(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { source: `${conversationId}: ${value}` })
  }
}

// CSME-91691
export function updateCampaignId(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { campaignId: `${conversationId}: ${value}` })
  }
}

// CSME-91691
export function updateCampaignVersionId(conversationId: string, value: string) {
  if (typeof window.updateCTRItem === 'function') {
    return window.updateCTRItem(conversationId, { campaignVersionId: `${conversationId}: ${value}` })
  }
}

/**
 * 
 * @param cards 
 * @param campaignId 
 * @param source 
 * @param campaignVersionId 
 * @param isSalesContact 
 * 
 * Prevents multiple consent status updates to 'No' during component remounts.
 * 
 * The consent status defaults to 'No' for support queue contacts. Since this function
 * can be triggered multiple times (due to App.tsx and WidgetFrame.tsx remounting as a widget there are 
 * chances of updating consent status to 'No' multiple times Eventthough the consent status is given 'Yes'
 * we check the current consent status from session storage to avoid overwriting an existing 'Yes' status with 'No'.
 */
export function updateCommonCTRAttributesForRU(cards, campaignId, source, campaignVersionId, isSalesContact) {
  const currConvId = getCurrConvId();
  const allCampaignNames = cards?.map(card => card.title) || [];
  const uniqueCampaignNames = allCampaignNames.filter((item, index) => allCampaignNames.indexOf(item) === index).join(', ');
  const allOfferDetails = cards.map(card => `${card.offerId}: No`).join(', ') || '';
  const sessionStorageData = getCurrentContactCTRData(currConvId);
  const { consentSendStatus, consentReceivedStatus, offerPitchFlagStatus, EligibleOffersPitchedValue } = sessionStorageData || {};

  // CTR Analytics - These are the default values to be updated for every RU eligible contact 
  // If cards are empty, we set the vaoEligibilityFlag to 'No', otherwise 'Yes' - analytics team confirmed on June 13th 2025 in slack
  cards?.length === 0 ? updateVaoEligibilityFlag(currConvId, 'No') : updateVaoEligibilityFlag(currConvId, 'Yes');
  updateCampaignId(currConvId, campaignId || 'NA');
  updateSourceAttribute(currConvId, source || 'NA');
  updateCampaignVersionId(currConvId, campaignVersionId || 'NA');

  // When CustomerId changing this field is not updating - CSME-95372
  if (isSalesContact) {
    updateConsentSend(currConvId, 'NA');
    updateConsentReceived(currConvId, 'NA'); // Sales queue will not have consent
    updateValueAddActionSupport(currConvId, '');
    updateValueAddActionSales(currConvId, uniqueCampaignNames);
  } else {
    if (consentSendStatus !== 'Yes') {
      updateConsentSend(currConvId, 'No');
    }

    if (consentReceivedStatus !== 'Yes') {
      updateConsentReceived(currConvId, 'No');
    }

    updateValueAddActionSales(currConvId, '');
    updateValueAddActionSupport(currConvId, uniqueCampaignNames);
  }

  if (offerPitchFlagStatus !== 'Yes') {
    updateOfferPitchFlag(currConvId, 'No');
  }

  if (!EligibleOffersPitchedValue?.includes('Yes')) {
    updateEligibleOffersPitchedToDefault(currConvId, allOfferDetails);
  }

  const persistCustomerSearchClick = sessionStorage.getItem(`ctr_updates_customersearch_${currConvId}`);

  updateCustomerSearchClick(currConvId, persistCustomerSearchClick || 'No');
}

/**
 * Gets current consent status from session storage
 * @param {string} contactId - The contactId
 * @returns {string|null} Current consent status or null if not found
 */
export function getCurrentContactCTRData(contactId) {
  let rengaId = ''
  if (typeof window.getLatestRengaId === 'function') {
    rengaId = window.getLatestRengaId();
  }
  
  try {
    const sessionData = sessionStorage.getItem(`ctr_updates_${contactId + rengaId}`);
    if (sessionData) {
      const data = JSON.parse(sessionData) || null;

      if (data) {
        const consentSendValue = data.consentSend?.split(': ')[1];
        const consentReceivedValue = data.consentReceived?.split(': ')[1];
        const offerPitchFlagValue = data.offerPitchFlag?.split(': ')[1];
        const EligibleOffersPitchedValue = data.EligibleOffersPitched;

        return {
          consentSendStatus: consentSendValue,
          consentReceivedStatus: consentReceivedValue,
          offerPitchFlagStatus: offerPitchFlagValue,
          EligibleOffersPitchedValue: EligibleOffersPitchedValue
        };
      }

    }
  } catch (error) {
    console.error('Error getting current consent status:', error);
  }
  return null;
}

export function updateCTROfferAnalytics(initialContactId: string, customerId: string) {
  const currentConvId = getCurrConvId();
  const currentState = store.getState().RUInfo.convData;
  const convDataKey = initialContactId + customerId;
  const cards = currentState[convDataKey]?.cards || [];
  const latestOffer = findLatestOffer(currentState[convDataKey]?.cards);
  const latestOfferStatus = latestOffer?.offerStatus;
  const allOfferDetails = cards.map(card => `${card.offerId}: ${card.offerStatus ? 'yes' : 'no'}`).join(', ') || '';

  updateEligibleOffersPitched(currentConvId, allOfferDetails);
  // updateVaoEligibilityFlag(currentConvId, 'Yes');

  if (!!latestOffer && typeof latestOffer === 'object') {
    updateOfferId(currentConvId, latestOffer.offerId);

    switch (latestOfferStatus) {
      case 'pitched':
        updateOfferPitchFlag(currentConvId, 'Yes');
        break;
      case 'accepted':
        updateOfferPitchFlag(currentConvId, 'Yes');
        updateOfferAcceptedFlag(currentConvId, 'Yes');
        break;
      case 'rejected':
        updateOfferPitchFlag(currentConvId, 'Yes');
        updateOfferAcceptedFlag(currentConvId, 'No');
        break;
      default:
        updateOfferPitchFlag(currentConvId, 'No');
        updateOfferAcceptedFlag(currentConvId, 'No');
    }
  }
}

function findLatestOffer(cards) {
  let latestOffer = null;
  let latestTimestamp = 0;

  Array.isArray(cards) && cards?.forEach(card => {
    if (card.lastUpdatedTimestamp > latestTimestamp) {
      latestTimestamp = card.lastUpdatedTimestamp;
      latestOffer = card;
    }
  });
  return latestOffer;
}

export function getCurrConvId() {
  if (typeof window.getCurrentConvID === 'function') {
    return window.getCurrentConvID();
  }
  return "";
}
